import { apiClient } from '../api';
import type { ApiResponse } from '@/types/auth';
import type {
  VerificationPricingResponse,
  VerificationResult,
  VerifyBvnRequest,
  VerifyNinRequest,
} from '@/types/verification';

class VerificationService {
  getPricing() {
    return apiClient.get<ApiResponse<VerificationPricingResponse>>('/users/verification/pricing');
  }

  verifyNin(body: VerifyNinRequest) {
    return apiClient.post<ApiResponse<VerificationResult>>('/users/verification/nin', body);
  }

  verifyBvn(body: VerifyBvnRequest) {
    return apiClient.post<ApiResponse<VerificationResult>>('/users/verification/bvn', body);
  }
}

export const verificationService = new VerificationService();
